/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var CourseClassificationVariantStatus;

(function (CourseClassificationVariantStatus) {
  CourseClassificationVariantStatus["ACTIVE"] = "ACTIVE";
  CourseClassificationVariantStatus["AUTO_ADDED"] = "AUTO_ADDED";
  CourseClassificationVariantStatus["AUTO_ADDED_INACTIVE"] = "AUTO_ADDED_INACTIVE";
  CourseClassificationVariantStatus["AUTO_ADDED_VIEWED"] = "AUTO_ADDED_VIEWED";
  CourseClassificationVariantStatus["AUTO_ADDED_VIEWED_INACTIVE"] = "AUTO_ADDED_VIEWED_INACTIVE";
  CourseClassificationVariantStatus["IN_ACTIVE"] = "IN_ACTIVE";
})(CourseClassificationVariantStatus || (CourseClassificationVariantStatus = {}));

export var CourseStatus;

(function (CourseStatus) {
  CourseStatus["ACTIVE"] = "ACTIVE";
  CourseStatus["IN_ACTIVE"] = "IN_ACTIVE";
})(CourseStatus || (CourseStatus = {}));

export var EntityOperationType;
/**
 * Deprecated UMIS Enum representing entity types supported for user content creation
 */

(function (EntityOperationType) {
  EntityOperationType["CREATE"] = "CREATE";
  EntityOperationType["DELETE"] = "DELETE";
  EntityOperationType["UPDATE"] = "UPDATE";
})(EntityOperationType || (EntityOperationType = {}));

export var EntityType;
/**
 * Professor Corsair Course Status
 */

(function (EntityType) {
  EntityType["COURSE"] = "COURSE";
  EntityType["COURSE_CLASSIFICATION"] = "COURSE_CLASSIFICATION";
  EntityType["SCHOOL"] = "SCHOOL";
})(EntityType || (EntityType = {}));

export var ProfessorCourseStatus;
/**
 * Different incentive type supported in professor profile service
 */

(function (ProfessorCourseStatus) {
  ProfessorCourseStatus["ACTIVE"] = "ACTIVE";
  ProfessorCourseStatus["IN_ACTIVE"] = "IN_ACTIVE";
})(ProfessorCourseStatus || (ProfessorCourseStatus = {}));

export var ProfessorIncentiveType;
/**
 * Professor Origin
 */

(function (ProfessorIncentiveType) {
  ProfessorIncentiveType["FIRST_TIME_UPLOAD_BONUS"] = "FIRST_TIME_UPLOAD_BONUS";
})(ProfessorIncentiveType || (ProfessorIncentiveType = {}));

export var ProfessorOrigin;
/**
 * Professor Corsair School Status
 */

(function (ProfessorOrigin) {
  ProfessorOrigin["GHOST"] = "GHOST";
  ProfessorOrigin["UVERSITY"] = "UVERSITY";
})(ProfessorOrigin || (ProfessorOrigin = {}));

export var ProfessorSchoolStatus;
/**
 * Professor Status
 */

(function (ProfessorSchoolStatus) {
  ProfessorSchoolStatus["ACTIVE"] = "ACTIVE";
  ProfessorSchoolStatus["IN_ACTIVE"] = "IN_ACTIVE";
})(ProfessorSchoolStatus || (ProfessorSchoolStatus = {}));

export var ProfessorStatus;
/**
 * Validation of professor should be done by one of the following validation provider
 */

(function (ProfessorStatus) {
  ProfessorStatus["ACTIVE"] = "ACTIVE";
  ProfessorStatus["IN_ACTIVE"] = "IN_ACTIVE";
})(ProfessorStatus || (ProfessorStatus = {}));

export var ProfessorValidationProvider;
/**
 * Professor Validation Status
 */

(function (ProfessorValidationProvider) {
  ProfessorValidationProvider["SHEER_ID"] = "SHEER_ID";
})(ProfessorValidationProvider || (ProfessorValidationProvider = {}));

export var ProfessorValidationStatus;
/**
 * Professor Mode of Validation
 */

(function (ProfessorValidationStatus) {
  ProfessorValidationStatus["DOCUMENT_REQUIRED"] = "DOCUMENT_REQUIRED";
  ProfessorValidationStatus["NOT_VERIFIED"] = "NOT_VERIFIED";
  ProfessorValidationStatus["PENDING"] = "PENDING";
  ProfessorValidationStatus["PENDING_EMAIL_CONFIRMATION"] = "PENDING_EMAIL_CONFIRMATION";
  ProfessorValidationStatus["REJECTED"] = "REJECTED";
  ProfessorValidationStatus["REQUEST_ACCEPTED"] = "REQUEST_ACCEPTED";
  ProfessorValidationStatus["REQUEST_IN_PROCESS"] = "REQUEST_IN_PROCESS";
  ProfessorValidationStatus["SSO_REQUIRED"] = "SSO_REQUIRED";
  ProfessorValidationStatus["VALIDATED"] = "VALIDATED";
})(ProfessorValidationStatus || (ProfessorValidationStatus = {}));

export var ProfessorValidationType;

(function (ProfessorValidationType) {
  ProfessorValidationType["INSTANT"] = "INSTANT";
  ProfessorValidationType["MANUAL"] = "MANUAL";
})(ProfessorValidationType || (ProfessorValidationType = {}));

export var SchoolStatus;

(function (SchoolStatus) {
  SchoolStatus["ACTIVE"] = "ACTIVE";
  SchoolStatus["IN_ACTIVE"] = "IN_ACTIVE";
})(SchoolStatus || (SchoolStatus = {}));

export var SchoolType;
/**
 * Deprecated UMIS Enum representing different status possible for a created content
 */

(function (SchoolType) {
  SchoolType["COLLEGE"] = "COLLEGE";
  SchoolType["HIGH_SCHOOL"] = "HIGH_SCHOOL";
})(SchoolType || (SchoolType = {}));

export var Status;

(function (Status) {
  Status["ACTIVE"] = "ACTIVE";
  Status["IN_ACTIVE"] = "IN_ACTIVE";
})(Status || (Status = {}));

export var StudentStatus;

(function (StudentStatus) {
  StudentStatus["ACTIVE"] = "ACTIVE";
  StudentStatus["IN_ACTIVE"] = "IN_ACTIVE";
})(StudentStatus || (StudentStatus = {})); //==============================================================
// END Enums and Input Objects
//==============================================================